import { ServiceBayDto, ServiceBayScheduleDto } from "../dtos/serviceBayDto";
import { ServiceBay, ServiceBaySchedule } from "../models/serviceBay";
import ApiService from "../services/api";

export const fetchServiceBay = async (serviceBayId: string): Promise<ServiceBay | undefined> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.get<any>(`/service-bay/${serviceBayId}`);
        if (response.status === 200) {
            return ServiceBayDto(response.data);
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchServiceBayList = async (): Promise<ServiceBay[] | undefined> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.get<any>(`/service-bay`);
        if (response.status === 200) {
            return response.data.map(ServiceBayDto);
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchServiceBayScheduleList = async (startDate: Date, endDate: Date, serviceBayIds: string[], options: { includeOccurrence: boolean } = { includeOccurrence: false }): Promise<ServiceBaySchedule[] | undefined> => {
    const apiService = new ApiService();
    try {
        const startDateString = startDate.toISOString().split('.')[0];
        const endDateString = endDate.toISOString().split('.')[0];
        const serviceBayIdsString = serviceBayIds.join('&serviceBayIds=');
        
        const response = await apiService.get<any>(`/service-bay-schedule?startDate=${startDateString}&endDate=${endDateString}&serviceBayIds=${serviceBayIdsString}`);
        if (response.status === 200) {
            return response.data.map((el: any) => ServiceBayScheduleDto(el, options.includeOccurrence ? el.occurrence : undefined));
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}